// --------------------------------------------------------------------------
// #101 – Contact lookup module
// --------------------------------------------------------------------------
// Author:      Zone
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');
var ModalDisplay = require('./modal');
var modalDisplay = new ModalDisplay();

module.exports = function (options) {
    var context = options.context;
    var externalExists = false;
    var button = context.find('[data-binding="contact-lookup"]');
    var addressHTMLEditAddressButton = '<button class="edit-selected-address" data-binding="edit-selected-address-button" type="button">Edit</button>';
    var contactTitle = $('#ContactDetails_Title');
    var contactFirstName = $('#ContactDetails_FirstName');
    var contactLastName = $('#ContactDetails_LastName');
    var contactEmail = $('#ContactDetails_EmailAddress');
    var contactHomePhone = $('#ContactDetails_HomePhone');
    var contactMobilePhone = $('#ContactDetails_MobilePhone');
    var contactPostcode = $('#Address_Postcode');
    var contactUnderAge = $('input[name="ContactDetails.UnderAgeString"]');
    var lookupInputs = $('[name="ContactLookup.Postcode"],[name="ContactLookup.ContactNumber"]');

    function init() {
        var formSectionContents = context.find('fieldset .submit-details-form-section__content');

        function populateModal(data) {
            var modal = context.find('[data-binding="modal"]');
            var modalResults = $('[data-binding="results"]');

            modalResults.html('');
            $.each(data.Names, function (index, item) {
                modalResults.append('<a class="button" href="' + data.Url + index + '"><span class="button__text">' + item + '</span></a>');
            });
            if (!externalExists) {
                externalExists = true;
                modalDisplay.externalModal(context, modal, 'contact');
            }
            context.find('[data-binding="open-modal"]').trigger('click');
        }

        formSectionContents.show();
        formSectionContents.siblings('.toggle').text('Hide');

        if (contactPostcode.val() !== '' && contactTitle.val() !== '' && contactFirstName.val() !== '' && contactLastName.val() !== '' && contactEmail.val() !== '') {
            var contactAddress = context.find('[data-binding*="address-part"]');

            context.find('.non-edittable-address').empty();
            context.find('.non-edittable-address').append('<div class="address-row">' + contactTitle.val() + ' ' + contactFirstName.val() + ' ' + contactLastName.val() + '</div><div class="address-row">' + contactEmail.val() + '</div>');
            if (contactHomePhone.val() !== '') {
                context.find('.non-edittable-address').append('<div class="address-row">' + contactHomePhone.val() + '</div>');
            }
            if (contactMobilePhone.val() !== '') {
                context.find('.non-edittable-address').append('<div class="address-row">' + contactMobilePhone.val() + '</div>');
            }
            $.each(contactAddress, function (index, value) {
                context.find('.non-edittable-address').append('<div class="address-row">' + $(value).val() + '</div>');
            });
            context.find('.non-edittable-address').append(addressHTMLEditAddressButton);
            context.find('#contact-details').hide();
            context.find('[data-binding="edit-address-fields"]').hide();
            context.find('[data-binding="postcode-lookup-wrapper"]').hide();
            context.find('.non-edittable-address').parent().show();
        }

        button.on('click', function (e) {
            e.preventDefault();

            var membershipNumberField = $(this).parent().find('.contact-lookup-number-input');
            var postcodeField = $(this).parent().find('.contact-lookup-postcode-input');

            if (membershipNumberField.val() === '' || postcodeField.val() === '') {
                if (membershipNumberField.val() === '') {
                    var membershipNumberError = membershipNumberField.prev();
                    membershipNumberError.removeClass('field-validation-valid').addClass('field-validation-error').text('Please enter a valid membership number.');
                }
                if (postcodeField.val() === '') {
                    var postcodeFieldError = postcodeField.prev();
                    postcodeFieldError.removeClass('field-validation-valid').addClass('field-validation-error').text('Please enter your postcode.');
                }
            } else {
                $.ajax({
                    data: context.find('form').serialize() + '&' + $(this).attr('name') + '=',
                    type: 'POST',
                    url: context.find('form').attr('action')
                }).done(function (data) {
                    if (data.Count === 1) {
                        location.reload();
                    } else if (data.Count === 0) {
                        membershipNumberField.prev().removeClass('field-validation-valid').addClass('field-validation-error').text(data.Error);
                    } else {
                        populateModal(data);
                    }
                });
            }
        });

        // prevent submitting the form on the Enter key pressed
        lookupInputs.on('keydown', function (e) {
            if (e.keyCode === 13) {
                e.preventDefault();
            }
        });

        context.on('click', '[data-binding="edit-selected-address-button"]', function (e) {
            e.preventDefault();
            context.find('.non-edittable-address').parent().hide();
            context.find('#contact-details').show();
            context.find('[data-binding="postcode-lookup-wrapper"]').show();
            context.find('[data-binding="edit-address-fields"]').slideDown();
        });

        function showContactDetails(highlighted) {
            context.find('[data-binding="edit-selected-address-button"]').trigger('click');
            context.find('[data-behavior*="under-age"]').toggleClass('under-age-highlighted', highlighted);
        }

        // check if there's an under age error
        var $validationSummary = context.find('.validation-summary-errors:visible').first();
        if ($validationSummary.length) {
            // look for DoB related errors
            if ($validationSummary.html().indexOf('date of birth') > -1 || $validationSummary.html().indexOf('under or over') > -1) {
                showContactDetails(true); // if there's a BE error highlight the question
            }
        } else {
            // check if the under age input has beem checked by a user, if not show contact details so that user can answer this question
            if (contactUnderAge.filter(':checked').length === 0) {
                showContactDetails(false);
            }
        }

        // on page reload check if there's a looked-up postcode value that should be present on the address lookup module as well
        if (context.find('input[name="Address.Postcode"]').val().length > 0 && context.find('input[name="Address.PostcodeLookup"]').val().length === 0) {
            // copy Address.Postcode to Address.PostcodeLookup
            context.find('input[name="Address.PostcodeLookup"]').val(context.find('input[name="Address.Postcode"]').val());
        }

        // auto scroll-down to the contact details form if lookup was used
        if (context.find('.validation-summary-valid').length > 0 && context.find('[name="ContactDetails.FirstName"]').val().length > 0) {
            // only if there's no error, otherwise jQuery.validate will scroll to error and there's a contact data available
            setTimeout(function () {
                $('html, body').animate({
                    scrollTop: context.find('.submit-details-form-section__heading').offset().top - 60
                }, 500);
            }, 500);
        }
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/contact-lookup.js
// module id = 226
// module chunks = 0